import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { compose, withProps } from "recompose";
import styles from "./MapStyles";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";

const defaultMapOptions = {
  mapTypeControl: false,
  zoomControl: false,
  scaleControl: false,
  styles: styles,
  streetViewControl: false,
  fullscreenControl: false,
  minZoom: 3
};

const MapCanvas = compose(
  withProps({
    loadingElement: <div style={{ height: `100%`, width: `100%` }} />,
    containerElement: <div style={{ height: `100%`, width: `100%` }} />,
    mapElement: <div style={{ height: `100%`, width: `100%` }} />
  }),
  withGoogleMap
)(({ selectedSchool, schoolSelection, schools = [] }) => {
  const mapComponent = useRef(null);

  const [mapCenter, setMapCenter] = useState({ lat: -25.2744, lng: 133.7751 });
  const [zoom, setZoom] = useState(4);

  const markerType = efficency => {
    const percent = efficency * 100;
    if (efficency) {
      if (percent <= 25) {
        return "low";
      }
      if (percent > 25 && percent < 50) {
        return "medium";
      }
      if (percent > 50 && percent < 75) {
        return "high";
      }
      if (percent > 75 && percent < 95) {
        return "very-high";
      }
      if (percent > 95) {
        return "extremely-high";
      }
    }
    return "not-defined";
  };

  // const centerMapToSchool = ({ latitude = false, longitude = false }) => {
  //   if (latitude && longitude) {
  //     setMapCenter({ lat: latitude, lng: longitude });
  //     setZoom(18);
  //     const { current } = mapComponent;
  //     if (current && typeof current.setZoom === "function") {
  //       current.setZoom(zoom);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   if (selectedSchool) {
  //     centerMapToSchool(selectedSchool);
  //   }
  // }, [selectedSchool]);

  return (
    <GoogleMap
      ref={mapComponent}
      options={defaultMapOptions}
      defaultZoom={4}
      zoom={zoom}
      onZoomChanged={() => {
        const { current = false } = mapComponent;
        if (current) {
          setZoom(current.getZoom());
        }
      }}
      center={mapCenter}
    >
      {schools.map(
        (
          { latitude, longitude, lastCompleteEnergyGeneratedEfficiency },
          index
        ) => (
          <Marker
            onClick={() => {
              schoolSelection(schools[index]);
            }}
            icon={`/img/marker-${markerType(
              lastCompleteEnergyGeneratedEfficiency
            )}.png`}
            key={index}
            position={{ lat: latitude, lng: longitude }}
          />
        )
      )}
    </GoogleMap>
  );
});

MapCanvas.propTypes = {
  schools: PropTypes.array.isRequired
};

export default MapCanvas;



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolMap/MapCanvas.js